<script>
    import addToBasket from "../events/addToBasket.js";

    /**
 *
 *
 *
 *
 */

    /*                */
    let { variationId, widgetAdditionalClickTracking, pageName } = $props();

    let add2basketButtonClicked = $state(false);

    const add2basketClickListener = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!add2basketButtonClicked) {
            add2basketButtonClicked = true;
            addToBasket(variationId, widgetAdditionalClickTracking, additionalClickTracking, pageName);
        }
    };
</script>

<oc-button-v1
    size="50"
    type="button"
    variant="secondary"
    icon-type-left="basket"
    class="reco_basketlayer_product_card__button"
    class:clicked={add2basketButtonClicked}
    onclick={add2basketClickListener}
    data-testid="add_to_basket_grey_button"
>
    <div class="overlay">
        <oc-icon-v1 type="check" size="50" style="margin-top: 10px;"></oc-icon-v1>
    </div>
    <span>Hinzufügen</span>
</oc-button-v1>

<style>
    .reco_basketlayer_product_card__button {
        .checkmark {
            position: absolute;
            z-index: 1;
            opacity: 0;
            transition: opacity 0.2s;
        }

        .overlay {
            background-color: #50cc7f;
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 8px;
            opacity: 0;
            transition: opacity 0.2s 0.2s;
        }

        span {
            transition: opacity 0.2s 0.4s;
        }

        .basket_icon {
            transition: opacity 0.2s 0.4s;
        }

        &.clicked {
            cursor: default;

            .checkmark {
                opacity: 1;
                transition: opacity 0.2s 0.4s;
            }

            .overlay {
                opacity: 1;
                transition: opacity 0.2s 0.2s;
                left: 0px;
                top: 0px;
            }

            span {
                opacity: 0;
                transition: opacity 0.2s;
            }

            .basket_icon {
                opacity: 0;
                transition: opacity 0.2s;
            }
        }
    }
</style>
